@if (isLoading) {
  <app-loader></app-loader>
}@else if (fileType === "Message/Email File"){
<app-email-view [data]="data" [isNewTab]="true"></app-email-view>
}@else {
<app-doc-container [data]="data" [isNewTab]="true"></app-doc-container>
}
